









































import Vue from 'vue';
import * as InputValidation from '@/mixins/inputValidation';

export default Vue.extend({
  props: {
    initialName: String,
    right: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      nameInput: this.initialName,
      sectionInput: '',
      descriptionInput: ''
    };
  },

  computed: {
    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250, true);
    },

    sectionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.sectionInput, 250, false);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.descriptionInput, 250, false);
    },

    createDisabled(): boolean {
      return (
        !this.nameValidation.valid ||
        !this.sectionValidation.valid ||
        !this.descriptionValidation.valid
      );
    }
  },

  methods: {
    onCreate() {
      this.$emit('create-group', {
        name: this.nameInput,
        section: this.sectionInput,
        description: this.descriptionInput
      });
    }
  },

  watch: {
    initialName(val) {
      this.nameInput = val;
    }
  }
});
